module.exports = __webpack_public_path__ + "media/gifts/gift-bbl-face-and-neck-treatment-e04241b4.png";